import { render, staticRenderFns } from "./Logo.vue?vue&type=template&id=5dfebc62&scoped=true&"
import script from "./Logo.vue?vue&type=script&lang=js&"
export * from "./Logo.vue?vue&type=script&lang=js&"
import style0 from "./Logo.vue?vue&type=style&index=0&id=5dfebc62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dfebc62",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/nisems/front/nisbos-front-admin/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5dfebc62')) {
      api.createRecord('5dfebc62', component.options)
    } else {
      api.reload('5dfebc62', component.options)
    }
    module.hot.accept("./Logo.vue?vue&type=template&id=5dfebc62&scoped=true&", function () {
      api.rerender('5dfebc62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Layout/components/Sidebar/Logo.vue"
export default component.exports